import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import {
  Row,
  Col,
  Input,
  Button,
  Select,
  Option,
  Menu,
  MenuItem,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Table,
  TableColumn,
  Pagination,
  Radio,
  RadioGroup,
  RadioButton,
  Dialog,
  Tabs,
  TabPane,
  Form,
  FormItem,
  DatePicker,
  Message,
  Checkbox,
  CheckboxGroup,
  CheckboxButton,
  Upload,
  Switch,
  Loading ,
  Tree,
  Steps,
  Step 
} from 'element-ui'

Vue.use(Row)
Vue.use(Col)
Vue.use(Input)
Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Dialog)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(DatePicker)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(CheckboxButton)
Vue.use(Upload)
Vue.use(Switch)
Vue.use(Loading)
Vue.use(Tree)
Vue.use(Steps)
Vue.use(Step)
Vue.prototype.$message = Message
